<template>
  <div class="new-details">
    <div class="new-details-width">
      <h2>{{ details.title }}</h2>
      <div class="new-details-content" v-html="details.content"></div>
      <div class="new-details-line"></div>
      <div class="new-details-button">
        <ul>
          <li :class="{ 'new-details-button__disabled': !details.previousPosts?.id }">
            <label for="pre">上一篇：</label>
            <a @click.stop="handleRouterPage(details.previousPosts)" id="pre">
              {{ details.previousPosts?.title || '没有了' }}
            </a>
          </li>
          <li :class="{ 'new-details-button__disabled': !details.nextChapter?.id }">
            <label for="next">下一篇：</label>
            <a @click.stop="handleRouterPage(details.nextChapter)" id="next">
              {{ details.nextChapter?.title || '没有了' }}
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { getNewsDetailsById } from '@/api/news'
export default {
  data() {
    return {
      details: {
        title: '',
        content: '',
        preNews: {},
        nextNews: {},
      },
    }
  },
  methods: {
    async getNewsDetailsById(id) {
      const { data } = await getNewsDetailsById(id)
      this.details = data
    },
    // 跳转到对应的页面
    handleRouterPage(item) {
      if (!item.id) return
      this.$router.push(`/news/${item.id}`)
      this.getNewsDetailsById(item.id)
    },
  },
  created() {
    const { params } = this.$route
    if (!params.id) return
    this.getNewsDetailsById(params.id)
  },
}
</script>

<style lang="less">
.new-details {
  padding-top: 120px;
  background: #f7f7f7;

  h2 {
    font-size: 32px;
    font-weight: bold;
    color: #333333;
    line-height: 48px;
  }

  &-content {
    margin: 30px 0 40px 0;

    section,
    p {
      margin: .9em 0;
    }
  }

  &-width {
    width: 1000px;
    height: 100%;
    margin: auto;

    img {
      display: inline-block ;
      max-width: 1000px;
      object-fit: cover;
      height:auto;
    }
  }

  &-line {
    height: 1px;
    border: 1px solid #eeeeee;
    width: 100%;
  }

  &-button {
    padding: 30px 0 110px 0;

    ul {
      li {
        font-size: 16px;
        font-weight: 400;
        color: #e62129;

        a {
          color: #e62129;
          cursor: pointer;
        }
      }

      li + li {
        margin-top: 32px;
      }
    }

    &__disabled {
      color: #999 !important;

      a {
        color: #999 !important;
        cursor: not-allowed !important;
      }
    }
  }
}
</style>
